export default __webpack_public_path__ + "static/media/meat.6db8db8e.webp";